module.exports = __webpack_public_path__ + "static/media/background6.398af357.mp4";